import { Validators } from "@angular/forms";
import { IFormKey } from "src/app/modules/shared/models/forms";

export const bank_account_change_form_template = {
    iban: null
}

export const bank_account_change_form_validators = {
    iban: [Validators.required]
}

export const bank_account_change_form_keys: IFormKey[] = [
    {
        id: 'iban-field',
        label: 'Coordinate bancarie',
        controlName: 'iban',
        css: 'col-4',
        type: 'SELECT',
        options: []
    }
];

export interface IBankAccountChangeIsvRequest {
    policyNumber: string;
    abi: string;
    cab: string;
    contoCorrente: string;
    iban: string;
}